<template>
    <ul>
        <li v-for="(value, index) in filteredOnlyMeasures" :key="index">
            {{ value }}
        </li>
    </ul>

    <trend
        :data="[0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0]"
        :gradient="['#6fa8dc', '#42b983', '#2c3e50']"
        auto-draw
        smooth
    >
    </trend>
</template>

<script>
export default {
    mounted() {
        console.log('Trend Chart mounted.')
    },
    data() {
        return {
            'measures': this.$store.state.measures,
            'filteredOnlyMeasures': this.$store.state.measures
        }
    },
    filters: {
        filteredOnlyMeasures() {
            /*let measures = payload.map(function (element) {
                console.log('pillao', element);
                return element.value_key;
            })


            return measures;*/

            console.log('hey', this.measures);

            return this.measures.map(function (element) {
                //console.log('pillao', element);

                return element.measured_at;
            });
        }
    }
}
</script>
